import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react-shared/Icon";
import { TippyV2 } from "@circle-react-shared/TippyV2";

export const TooltipIcon = ({ tooltipKey, tooltipProps }: any) => (
  <TippyV2 className="flex items-center" content={t(tooltipKey, tooltipProps)}>
    <Icon type="16-info" size={16} className="ml-2" />
  </TippyV2>
);
